import { render, staticRenderFns } from "./ImageFeaturedMini.vue?vue&type=template&id=7dd2a76c"
import script from "./ImageFeaturedMini.vue?vue&type=script&lang=js"
export * from "./ImageFeaturedMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports